import type { PostType } from "@sorcery/cms";
import { H3, InternalLink, P } from "@sorcery/ui";

import { newsItemPath } from "~/utils/paths";
import { PostDate } from "../PostDate";
import { PostHeroImage } from "../PostHeroImage";

export const PostPreview = ({
  post,
  date = true,
}: {
  post: PostType;
  date?: boolean;
}) => {
  const { coverImage, date: postDate, excerpt, title, slug } = post;
  return (
    <div>
      <InternalLink
        className="group flex flex-col duration-300 hover:scale-[1.01] hover:opacity-50"
        href={newsItemPath(slug)}
      >
        <div className="relative mb-4 ">
          <div className="gradient-mask-b-90">
            <PostHeroImage slug={slug} source={coverImage} />
          </div>
        </div>
        <div>
          <H3 className="!mb-2 line-clamp-2 text-big-text-color transition-all">{title}</H3>

          {date && (
            <PostDate dateString={postDate} className="mb-1 block text-base !text-text-color" />
          )}

          <P className="line-clamp-2 max-w-xl text-lg opacity-70">{excerpt}</P>
        </div>
      </InternalLink>
    </div>
  );
};
